import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { config } from './config';
import { hmrBootstrap } from './hmr';

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (config.production) {
  enableProdMode();
  bootstrap();
} else {
  hmrBootstrap(module, bootstrap);
}



// WEBPACK FOOTER //
// ./src/main.ts